import { useContext, useState } from 'react'
import axios from 'axios'
import '../ResumeFromEmail.css'
import { observer } from 'mobx-react'
import { StoreContext } from '@store/Root.store'
import { Header, Button } from '../../Generic'

import { cx } from '@/utils/cx'
import { devLog } from '@methods/devLog'

interface IntroProps {
  nextStep: () => void
  phoneNumber: string
  sendOtpUrl: string
}

export const Intro = observer(({ nextStep, phoneNumber, sendOtpUrl }: IntroProps) => {
  const store = useContext(StoreContext)
  const { resumeFromEmailPage: trans } = store.TranslationsState.translations

  const [disabled, setDisabled] = useState(false)

  const sendOtp = async () => {
    setDisabled(true)

    try {
      await axios.post(sendOtpUrl, {}, { withCredentials: true })
    } catch (error) {
      devLog(error)
    }

    nextStep()
    setDisabled(false)
  }

  return (
    <>
      <Header className="m-30-0">{trans.InfoPage?.header}</Header>

      <p className="generic__intro-paragraph centered">{trans.InfoPage?.description}</p>

      <div className="layout__margined m-0-0-30" />

      <p className="generic__intro-paragraph centered resume-from-email__phone-number">
        {phoneNumber}
      </p>

      <div className="layout__margined m-0-0-30" />

      <div
        className={cx(
          'layout__content-container-bottom-fixed',
          'layout__content-container-bottom-fixed--border-top-none'
        )}
      >
        <Button disabled={disabled} onClick={sendOtp} className="button--w190">
          <span className="generic__button-text">{trans.InfoPage?.proceed}</span>
        </Button>
      </div>

      <div className="layout__mobile-spacer-for-content-container-bottom-fixed" />
    </>
  )
})
